import { toggleSearch} from './lib/header';
import { doSearch } from './lib/search';
import './lib/load-search-results.js';
import './lib/search-pagination.js';

doSearch();
toggleSearch();
